import packageJson from "../../../package.json";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import imgLogo from "../../Assets/images/logo_connectserasa_branco.png";
import imgLogoSafeWeb from "../../Assets/images/logo-Safeweb-branco.png";
import imgLogoOnline from "../../Assets/images/logo-Online-branco.png";

function Footer({ contexto }) {
  const currentDate = new Date().getFullYear();
  const facebook =
    contexto.facebook && contexto.facebook !== ""
      ? contexto.facebook
      : "https://www.facebook.com/connectsaoficial/";
  const instagram =
    contexto.instagram && contexto.instagram !== ""
      ? contexto.instagram
      : "https://www.instagram.com/connectsaoficial/";
  const linkedin =
    contexto.linkedin && contexto.linkedin !== ""
      ? contexto.linkedin
      : "https://www.linkedin.com/company/connectsaoficial";
  let linkSejaConnect = [];
  for (let i = 0; i <= 12; i++) {
    if (contexto.linkSejaConnect && i === 10) {
      linkSejaConnect.push("" + contexto.linkSejaConnect);
    } else {
      linkSejaConnect.push("https://www.connectsa.com.br/solucoes-connect/");
    }
  }

  return (
    <div>
      <div className="bg-[#000000e6] py-10">
        <div className="container w-10/12 mx-auto">
          <div className="grid grid-cols-3 gap-4 pt-4 pb-4 text-gray-connect hidden md:grid">
            <div className="">
              <div className="">
                <div className="mb-4">
                  <img src={imgLogo} alt="rodape-img" />
                </div>
                <p className="mb-4">
                  A Connect é Distribuidor Autorizado Serasa Experian, oferece
                  soluções nas áreas de informações de crédito e cadastro e
                  monitoramento de documentos de pessoas jurídicas para
                  prevenção de fraudes.
                </p>
                <a className="bg-green-connect text-center rounded px-20 py-2 text-white w-100" href="http://www.connectsa.com.br/" target="_blank">
                  Saiba mais
                </a>
              </div>
            </div>
            <div className="">
              <div className="">
                <div className="mb-4">
                  <img src={imgLogoSafeWeb} alt="rodape-img" />
                </div>
                <p>
                  Informações digitais seguras e confiáveis. <br></br>
                  Somos a SafeWeb a 2ª Maior emissora de Certificados Digitais
                  do Brasil
                </p>
              </div>
            </div>
            <div className="">
              <div className="">
                <div className="mb-4">
                  <img src={imgLogoOnline} alt="rodape-img" />
                </div>
                <p>
                  Certificados Digitais e soluções comerciais para cada etapa do
                  seu negócio. Fique Online e conte com a gente para levar sua
                  empresa cada vez mais longe
                </p>
              </div>
            </div>
          </div>
          <div className="columns-1 text-center text-xs pt-8 text-white">
            <p>® {currentDate} Connect - Todos os direitos reservados </p>
            <p>
              Desenvolvido por <span className="text-green-connect">Connect SA</span>
              <br />
              {packageJson.version}
            </p>
            <h4 className="text-lg mt-2">
              <a className="text-green-connect m-1" href={`${facebook}`} target="_blank">
                <FacebookIcon />
              </a>
              <a className="text-green-connect m-1" href={`${instagram}`} target="_blank">
                <InstagramIcon />
              </a>
              <a className="text-green-connect m-1" href={`${linkedin}`} target="_blank">
                <LinkedInIcon />
              </a>
            </h4>{" "}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
